import { useRef } from 'react';

/**
 * @description state의 값을 구독하지 않고 최신 값을 가져올 수 있는 getter를 반환
 */
export const useGetter = <T>(value: T) => {
  const valueRef = useRef(value);

  // eslint-disable-next-line react-hooks/refs -- stale closure 방지를 위해 최신값을 ref에 동기화하는 의도적 패턴
  valueRef.current = value;

  const getterRef = useRef(() => valueRef.current);

  // eslint-disable-next-line react-hooks/refs -- 렌더 중 getter 함수를 반환하는 최신값 ref 유틸 훅의 의도적 패턴
  return getterRef.current;
};
